import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import generateUtilityClass from '@mui/utils/generateUtilityClass';
export function getStackUtilityClass(slot) {
  return generateUtilityClass('MuiStack', slot);
}
const stackClasses = generateUtilityClasses('MuiStack', ['root']);
export default stackClasses;


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/Stack/stackClasses.js
// module id = 862
// module chunks = 25